<div class="validation-buttons">
  <a class="validation-buttons__addDiagnosis" *ngIf="!disabled" (click)="addNewDiagnosis()" >+ Add diagnosis</a>
</div>
